import React from "react";
import { CommentsSection } from "@/components/rdo/CommentsSection";

interface LegacyCommentsSectionProps {
  value: any;
  onChange: (value: any) => void;
  mode: "edit" | "view";
}

export function LegacyCommentsSection({ value, onChange, mode }: LegacyCommentsSectionProps) {
  // Temporary wrapper for legacy comments - this should use the existing CommentsSection component
  // For now, render a placeholder that maintains the current functionality
  
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Comentários (Legacy)</h3>
      <div className="text-sm text-muted-foreground">
        Sistema de comentários legado - será substituído pelo novo sistema
      </div>
      {/* Here we would render the existing CommentsSection or maintain current behavior */}
      <CommentsSection
        comments={value || []}
        reportStatus={mode === "view" ? "approved" : "draft"}
        currentUserId="current-user"
        onAddComment={(text, parentId) => {
          const newComment = {
            id: crypto.randomUUID(),
            authorId: "current-user",
            authorName: "Usuário Atual",
            text,
            datetime: new Date().toISOString(),
            parentId: parentId || null,
          };
          onChange([...(value || []), newComment]);
        }}
        onEditComment={(id, text) => {
          const updated = (value || []).map((comment: any) =>
            comment.id === id ? { ...comment, text } : comment
          );
          onChange(updated);
        }}
        onDeleteComment={(id) => {
          const filtered = (value || []).filter((comment: any) => comment.id !== id);
          onChange(filtered);
        }}
      />
    </div>
  );
}